import moment from "moment";
import React, { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ReactSelect from "react-select";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

const MaterialSummary = () => {
  const location = useLocation();
  const history = useHistory();

  const searchParams = new URLSearchParams(location.search);
  const [data, setData] = useState([]);
  // const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [materialOptions, setMaterialOptions] = useState([]);
  const [updatedAt, setUpdatedAt] = useState();

  const [filter, setFilter] = useState({
    warehouseId: searchParams.get('warehouseId') || undefined,
    materialId: +searchParams.get('materialId') || undefined,
  });

  const [rangeDate, setRangeDate] = useState({
    start: searchParams.get('start') ? moment(searchParams.get('start')).startOf('days').toDate() : moment().startOf("months").toDate(),
    end: searchParams.get('end') ? moment(searchParams.get('end')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({
      start: start ? moment(start)?.startOf("days").toDate() : start,
      end: end ? moment(end)?.endOf("days").toDate() : end,
    });
    if (start && end) {
      setUpdatedAt(moment().valueOf());
    }
  };

  useEffect(() => {
    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });

    GET("/material", {}, true).then((resp) => {
      setMaterialOptions(
        resp.data?.map(
          (c) =>
          ({
            label: `${c.name}(${c.unit})`,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, [])

  const colTable = [
    {
      Header: "Vật tư",
      accessor: (item) => item?.name
    },
    {
      Header: "Đơn vị",
      accessor: (item) => item?.unit,
    },
    {
      Header: "Tồn đầu kỳ",
      sortable: true,
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.firstQuantity || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Tăng",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.increaseQuantity || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Giảm",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={Math.abs(item.decreaseQuantity || 0)}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Tồn cuối kỳ",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.lastQuantity || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },

  ];

  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
      ...(filter.materialId ? { materialId: filter.materialId } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });


    setLoading(true);
    setData([]);
    const params = {
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
      ...(filter.materialId ? { materialId: filter.materialId } : {}),
      fromDate: moment(rangeDate.start).format('YYYY-MM-DD'),
      toDate: moment(rangeDate.end).format('YYYY-MM-DD'),
    }
    GET(`material-inventory/summary-inventory`, params, true)
      .then(({ data: { rows, summary } }) => {
        setData([...rows]);
        // setSummary(summary);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [updatedAt, filter]);

  return (
    <React.Fragment>
      <Head title="Báo cáo kho vật tư"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo kho vật tư</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">

                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.start}
                          startDate={rangeDate.start}
                          onChange={onRangeChange}
                          endDate={rangeDate.end}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          isClearable
                          placeholder="Lọc theo kho"
                          classNamePrefix="form-control"
                          options={warehouseOptions}
                          value={warehouseOptions.find(
                            (c) => c.value === filter.warehouseId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              warehouseId: val?.value,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          isClearable
                          placeholder="Lọc theo vật tư"
                          classNamePrefix="form-control"
                          options={materialOptions}
                          value={materialOptions.find(
                            (c) => c.value === filter.materialId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              materialId: val?.value,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <Button
                        color="primary"
                        onClick={() => {
                          history.goBack();
                        }}
                      >
                        <span>Trở về</span>
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <h5 className="text-center mt-2">Báo cáo kho vật tư từ {moment(rangeDate.start).format('DD-MM-YYYY')} đến {moment(rangeDate.end).format('DD-MM-YYYY')} </h5>
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  // headerRow={
                  //   <tr className="font-weight-bold">
                  //     <td colSpan={2}>Tổng</td>
                  //     <td className=" text-right">
                  //       <NumericFormat
                  //         displayType={"text"}
                  //         value={summary.firstQuantity || 0}
                  //         thousandsGroupStyle="thousand"
                  //         thousandSeparator=","
                  //         decimalScale={2}
                  //       />
                  //     </td>
                  //     <td className=" text-right">
                  //       <NumericFormat
                  //         displayType={"text"}
                  //         value={summary.increaseQuantity || 0}
                  //         thousandsGroupStyle="thousand"
                  //         thousandSeparator=","
                  //         decimalScale={2}
                  //       />
                  //     </td>
                  //     <td className=" text-right">
                  //       <NumericFormat
                  //         displayType={"text"}
                  //         value={Math.abs(summary.decreaseQuantity || 0)}
                  //         thousandsGroupStyle="thousand"
                  //         thousandSeparator=","
                  //         decimalScale={2}
                  //       />
                  //     </td>
                  //     <td className=" text-right">
                  //       <NumericFormat
                  //         displayType={"text"}
                  //         value={summary.lastQuantity || 0}
                  //         thousandsGroupStyle="thousand"
                  //         thousandSeparator=","
                  //         decimalScale={2}
                  //       />
                  //     </td>
                  //   </tr>
                  // }
                  />
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default MaterialSummary;
